import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DashboardApiPayload } from "types/dashboard.api";
import { getDashboard } from "./thunk";
import { ApiResponse } from "types/ApiResponse";
import { deleteQuote } from "slices/thunks";

export interface DashboardState {
  dashboard: DashboardApiPayload | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  errors: string | null;
}

export const initialState: DashboardState = {
  dashboard: null,
  status: "idle",
  errors: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDashboard.pending, (state) => {
      state.status = "loading";
      state.errors = null;
    });
    builder.addCase(
      getDashboard.fulfilled,
      (state, action: PayloadAction<ApiResponse<DashboardApiPayload>>) => {
        state.status = "succeeded";
        state.dashboard = action.payload.payload;
      }
    );
    builder.addCase(getDashboard.rejected, (state, action) => {
      state.status = "failed";
      state.errors = action.payload || null;
    });

    builder.addCase(
      deleteQuote.fulfilled,
      (state, action: PayloadAction<ApiResponse<number>>) => {
        const deletedQuoteId = action.payload.payload;
        console.log("deletedQuoteId", deletedQuoteId);
        if (state.dashboard) {
          state.dashboard.recentActivities =
            state.dashboard.recentActivities.filter(
              (activity) => activity.id !== deletedQuoteId
            );
        }
      }
    );
  },
});

export default dashboardSlice.reducer;

export const selectDashboardState = (state: any) =>
  state.dashboard as typeof initialState;
